import { render, staticRenderFns } from "./QuestionIcon.vue?vue&type=template&id=a13169d2&scoped=true&"
import script from "./QuestionIcon.vue?vue&type=script&lang=js&"
export * from "./QuestionIcon.vue?vue&type=script&lang=js&"
import style0 from "./QuestionIcon.vue?vue&type=style&index=0&id=a13169d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13169d2",
  null
  
)

export default component.exports